import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon30: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        d="M10.038 0C11.121 0 12 .879 12 1.962v.543a.5.5 0 0 1-1 0v-.543A.962.962 0 0 0 10.038 1H1.962A.962.962 0 0 0 1 1.962v16.076c0 .53.431.962.962.962h8.076a.962.962 0 0 0 .962-.962v-1.537a.5.5 0 0 1 1 0v1.537A1.963 1.963 0 0 1 10.038 20H1.962A1.963 1.963 0 0 1 0 18.038V1.962C0 .879.879 0 1.962 0h8.076ZM6.5 17a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1ZM18.04 5A1.96 1.96 0 0 1 20 6.96v4.078A1.963 1.963 0 0 1 18.037 13h-6.329l-2.854 2.854A.5.5 0 0 1 8 15.5V13h-.038A1.962 1.962 0 0 1 6 11.038V6.962C6 5.879 6.879 5 7.962 5H18.04Zm0 1H7.962A.962.962 0 0 0 7 6.962v4.076c0 .531.431.962.962.962H8.5a.5.5 0 0 1 .5.5v1.793l2.147-2.147A.5.5 0 0 1 11.5 12h6.537a.963.963 0 0 0 .963-.962V6.96a.96.96 0 0 0-.96-.96ZM10.5 9a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm6 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm-3 0a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1h1Zm-6-7a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1h3Z"
      />
    </Svg>
  )
}
